import React, { useState, useEffect } from "react";
import "./Shop.css";
import { Menu, Button, Input, Modal, Dropdown, Space } from "antd";
import FaqQuestions from "../FAQ/faqQuestions";
import { Flex, Rate, message } from "antd";
// import { Dropdown } from "bootstrap";
import star from "../../Assets/icons/star.png";
import { CheckCircleFilled, EllipsisOutlined } from "@ant-design/icons";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Instance from "../../AxiosConfig";
import { Collapse } from "antd";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoFilterSharp } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";


const { Panel } = Collapse;
const items = [
  {
    label: "Product Details",
    key: "first",
  },
  {
    label: "Ratings & Reviews",
    key: "second",
  },
];

const ProductReview = () => {
  const [value, setValue] = useState(0);
  const params = useParams();
  const { state } = useLocation();
  const [current, setCurrent] = useState("first");
  const [modalVisible, setModalVisible] = useState(false);
  const [succesModalVisible, setSuccesModalVisible] = useState(false);
  const [reviewData, setReviewData] = useState("");
  const [formData, setFormData] = useState({ name: "", review: "" });
  const [product, setProduct] = useState({});
  const [expandedSections, setExpandedSections] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("Latest");

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    if (state?.currentTab) {
      setCurrent(state.currentTab);
    }
  }, [state]);
  const sections = [
    { title: "Overview", content: product.overview },
    { title: "Features", content: product.features },
    { title: "Specifications", content: product.specifications },
    { title: "Applications", content: product.applications },
    { title: "Benefits", content: product.benefits },
    { title: "Usage Instructions", content: product.usageInstructions },
  ];
  const onClick = (e) => {
    console.log("Selected tab key:", e.key);
    setCurrent(e.key);
  };


  const toggleSection = (section) => {
    setExpandedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDelete = async (ratingReviewId) => {
    console.log("ratingReviewId", ratingReviewId)
    try {
      const url = `/api/v1/rating/review/${ratingReviewId}`;
      const response = await Instance.delete(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          'Content-Type': 'application/json',
        },
      });
      if (response.status === 200) {

        message.success(response.data.message);
        fetchReviewData();
      }
      
    } catch (error) {
      // Log the error for debugging
      console.log({ error });
  
      if (error.response && error.response.status === 400) {
        // Display the error message from the API response
        message.error(error.response.data.message);
      } else {
        // Generic error message for other cases
        message.error("Failed to delete the review");
      }
    }
  };

  const handleReview = async () => {
    if (value === 0) {
      message.error("Please select a rating before submitting.");
      return;
    }
    setSuccesModalVisible(true);

    try {
      const url = `/api/v1/rating/review/create/${params.productId}`;
      const response = await Instance.post(
        url,
        {
          review: formData.review,
          rating: value,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      if (response.status === 200) {
        message.success("review submitted successfully");
        setSuccesModalVisible(true);
        setModalVisible(false);
        setFormData({ name: "", review: "" });
        setValue(0); // Reset the rating value
        fetchReviewData();
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "An error occurred while submitting"
      );
    }
  };

  const fetchProductDetails = async () => {
    try {
      const response = await Instance.get(
        `/api/v1/products/${params.productId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      if (response.status === 200) {
        const productData = response.data;
        setProduct(productData);
        console.log("Product details:", response.data);
      }
    } catch (error) {
      message.error("An error occurred while fetching product details");
    }
  };

  const fetchReviewData = async () => {
    try {
      const url = `/api/v1/rating/review/${params.productId}`;
      const response = await Instance.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      if (response.status === 200) {
        console.log("review data fetched successfully:", response.data);
        const formattedReviews = response.data.map((review) => {
          const date = new Date(review.createdDate);
          const formattedDate = new Intl.DateTimeFormat("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          }).format(date);
          return {
            ...review,
            formattedDate: `Posted on ${formattedDate}`,
          };
        });
        setReviewData(formattedReviews);
        console.log("Formatted reviews", formattedReviews)
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "An error occurred");
    } finally {
    }
  };

  useEffect(() => {
    fetchProductDetails();
    fetchReviewData();
  }, [params.productId]);

  const reviews = reviewData.length > 0 ? reviewData : [];
  const [showAllReviews, setShowAllReviews] = useState(false);

  const handleToggleClick = () => {
    setShowAllReviews(!showAllReviews);
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);

    let sortedReviews = [...reviewData];
    if (filter === "Latest") {
      sortedReviews.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    } else if (filter === "High to Low") {
      sortedReviews.sort((a, b) => b.rating - a.rating);
    } else if (filter === "Low to High") {
      sortedReviews.sort((a, b) => a.rating - b.rating);
    }
    setReviewData(sortedReviews);
  };

  const filterMenu = (
    <Menu>
      <Menu.Item onClick={() => handleFilterChange("Latest")}>Latest</Menu.Item>
      <Menu.Item onClick={() => handleFilterChange("High to Low")}>High to Low</Menu.Item>
      <Menu.Item onClick={() => handleFilterChange("Low to High")}>Low to High</Menu.Item>
    </Menu>
  );

  const reviewsToDisplay = showAllReviews ? reviews : reviews.slice(0, 6);

  const navigate = useNavigate();

  const redirectToShopPage = () => {
    navigate("/shop");
  };

  const handleReviewModal = () => {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      setModalVisible(true);
    } else {
      navigate("/signin");
    }
  };

  return (
    <div className="product-review-container">
      <div className="product-review-menu-container">
        <Menu
          onClick={onClick}
          selectedKeys={[current]}
          mode="horizontal"
          items={items}
          className="product-review-menu"
        />
      </div>
      <div className="container product-review-content">
        {current === "first" && (
          <div>
            <h3>Product Description: {product.description}</h3>
            <h3>Product Name: {product.title}</h3>
            <div style={{ marginBottom: "1rem", borderRadius: "5px" }}>
              {/* <h2>{product.description} – Product Description</h2>
      <h3>Product Name: {product.title}</h3> */}
              <div>
                {sections.map((section, index) => (
                  section.content && (
                    <div key={index} style={{ marginBottom: "15px" }}>
                      <div
                        onClick={() => handleToggle(index)}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          padding: "7px",
                          backgroundColor: "#fff", // Updated background color to white
                          borderRadius: "4px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                          marginTop: "20px",
                        }}
                      >
                        <h3
                          style={{
                            margin: 0,
                            fontWeight: "bold",
                            fontSize: "18px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {section.title}
                        </h3>
                        <span
                          style={{
                            fontSize: "18px",
                            backgroundColor: "#E6EFFD",
                            borderRadius: "50px",
                            padding: "5px 10px",
                            color: "#000",
                            fontWeight: "bold",
                          }}
                        >
                          {activeIndex === index ? "-" : "+"}
                        </span>
                      </div>
                      {activeIndex === index && (
                        <div
                          style={{
                            padding: "10px",
                            border: "1px solid #f0f0f0",
                            borderTop: "none",
                            backgroundColor: "#fff",
                            marginTop: "10px",
                          }}
                        >
                          <div
                            className="section-para-space"
                            dangerouslySetInnerHTML={{ __html: section.content }}
                          />
                        </div>
                      )}
                    </div>
                  )
                ))}
              </div>


            </div>
          </div>
        )}
        {current === "second" && (
          <div>
            <div className="container">
              <div className="d-flex justify-content-between mb-4 media-productreview">
                <h5>All Reviews ({reviews.length})</h5>
                <div className="d-flex gap-4">
                  <Dropdown overlay={filterMenu} trigger={['click']}>
                    <div
                      style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                      aria-expanded="false"
                    >
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.658203"
                          y="0.800049"
                          width="62.5548"
                          height="62.5548"
                          rx="31.2774"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M33.4015 31.5888V42.8291C33.4015 43.2179 33.2471 43.5909 32.9721 43.8658C32.6972 44.1408 32.3242 44.2952 31.9354 44.2952C31.5466 44.2952 31.1736 44.1408 30.8987 43.8658C30.6237 43.5909 30.4693 43.2179 30.4693 42.8291V31.5888C30.4693 31.1999 30.6237 30.827 30.8987 30.5521C31.1736 30.2771 31.5466 30.1226 31.9354 30.1226C32.3242 30.1226 32.6972 30.2771 32.9721 30.5521C33.2471 30.827 33.4015 31.1999 33.4015 31.5888ZM40.7322 39.8968C40.3433 39.8968 39.9704 40.0513 39.6955 40.3263C39.4205 40.6012 39.266 40.9741 39.266 41.363V42.8291C39.266 43.2179 39.4205 43.5909 39.6955 43.8658C39.9704 44.1408 40.3433 44.2952 40.7322 44.2952C41.121 44.2952 41.4939 44.1408 41.7689 43.8658C42.0438 43.5909 42.1983 43.2179 42.1983 42.8291V41.363C42.1983 40.9741 42.0438 40.6012 41.7689 40.3263C41.4939 40.0513 41.121 39.8968 40.7322 39.8968ZM43.6644 35.0097H42.1983V21.3259C42.1983 20.937 42.0438 20.5641 41.7689 20.2892C41.4939 20.0142 41.121 19.8597 40.7322 19.8597C40.3433 19.8597 39.9704 20.0142 39.6955 20.2892C39.4205 20.5641 39.266 20.937 39.266 21.3259V35.0097H37.7999C37.4111 35.0097 37.0382 35.1642 36.7632 35.4392C36.4882 35.7141 36.3338 36.087 36.3338 36.4759C36.3338 36.8647 36.4882 37.2376 36.7632 37.5126C37.0382 37.7875 37.4111 37.942 37.7999 37.942H43.6644C44.0533 37.942 44.4262 37.7875 44.7011 37.5126C44.9761 37.2376 45.1306 36.8647 45.1306 36.4759C45.1306 36.087 44.9761 35.7141 44.7011 35.4392C44.4262 35.1642 44.0533 35.0097 43.6644 35.0097ZM23.1386 35.9872C22.7498 35.9872 22.3769 36.1416 22.1019 36.4166C21.827 36.6915 21.6725 37.0644 21.6725 37.4533V42.8291C21.6725 43.2179 21.827 43.5909 22.1019 43.8658C22.3769 44.1408 22.7498 44.2952 23.1386 44.2952C23.5275 44.2952 23.9004 44.1408 24.1753 43.8658C24.4503 43.5909 24.6048 43.2179 24.6048 42.8291V37.4533C24.6048 37.0644 24.4503 36.6915 24.1753 36.4166C23.9004 36.1416 23.5275 35.9872 23.1386 35.9872ZM26.0709 31.1001H24.6048V21.3259C24.6048 20.937 24.4503 20.5641 24.1753 20.2892C23.9004 20.0142 23.5275 19.8597 23.1386 19.8597C22.7498 19.8597 22.3769 20.0142 22.1019 20.2892C21.827 20.5641 21.6725 20.937 21.6725 21.3259V31.1001H20.2064C19.8175 31.1001 19.4446 31.2545 19.1697 31.5295C18.8947 31.8044 18.7402 32.1774 18.7402 32.5662C18.7402 32.955 18.8947 33.3279 19.1697 33.6029C19.4446 33.8779 19.8175 34.0323 20.2064 34.0323H26.0709C26.4597 34.0323 26.8326 33.8779 27.1076 33.6029C27.3825 33.3279 27.537 32.955 27.537 32.5662C27.537 32.1774 27.3825 31.8044 27.1076 31.5295C26.8326 31.2545 26.4597 31.1001 26.0709 31.1001ZM34.8677 25.2355H33.4015V21.3259C33.4015 20.937 33.2471 20.5641 32.9721 20.2892C32.6972 20.0142 32.3242 19.8597 31.9354 19.8597C31.5466 19.8597 31.1736 20.0142 30.8987 20.2892C30.6237 20.5641 30.4693 20.937 30.4693 21.3259V25.2355H29.0031C28.6143 25.2355 28.2414 25.39 27.9664 25.665C27.6915 25.9399 27.537 26.3128 27.537 26.7017C27.537 27.0905 27.6915 27.4634 27.9664 27.7384C28.2414 28.0133 28.6143 28.1678 29.0031 28.1678H34.8677C35.2565 28.1678 35.6294 28.0133 35.9044 27.7384C36.1793 27.4634 36.3338 27.0905 36.3338 26.7017C36.3338 26.3128 36.1793 25.9399 35.9044 25.665C35.6294 25.39 35.2565 25.2355 34.8677 25.2355Z"
                          fill="#757575"
                        />
                      </svg>
                      <span style={{ marginLeft: 8 }}>{selectedFilter}</span>
                    </div>
                  </Dropdown>

                  <button className="faq-get-in-touch-button-review" onClick={handleReviewModal}>
                    Write a Review
                  </button>
                </div>
              </div>
              <div className="row">
                {reviewsToDisplay.map((review, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="card p-4" style={{ height: "250px" }}>
                      <div className="d-flex justify-content-between">
                        <Flex gap="middle" vertical>
                          <Rate onChange={setValue} value={review.rating} />
                        </Flex>
                        <Dropdown
                          overlay={
                            <Menu>
                              <Menu.Item
                                key="delete"
                                onClick={() => handleDelete(review.ratingReviewId)}
                                className="ProjectReviews-delete-button d-flex align-items-center"
                              >
                                <RiDeleteBin6Line className="mb-1"/> {" "}
                                Delete
                              </Menu.Item>
                            </Menu>
                          }
                          trigger={["click"]}
                        >
                          <EllipsisOutlined style={{ fontSize: "24px", cursor: "pointer" }} />
                        </Dropdown>
                      </div>
                      <div className="d-flex gap-2 pt-2">
                        <h6>{review.userName}</h6>
                        <CheckCircleFilled
                          style={{ color: "green", marginBottom: "8px" }}
                        />
                      </div>
                      <p>{review.review}</p>
                      <span>{review.formattedDate}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="d-flex justify-content-center mt-4 ">
              {reviews.length > 6 && (
                <button
                  className="faq-get-in-touch-button"
                  onClick={handleToggleClick}
                >
                  {showAllReviews ? "View less" : "View all Reviews"}
                </button>
              )}
            </div>
          </div>
        )}
        {/* {current === "third" && (
          <div className="container text-align-center">
            <FaqQuestions />
          </div>
        )} */}
      </div>
      <Modal
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[]}
      >
        <div className="review-form">
          <h3 style={{ textAlign: "center" }}>Share your experience by leaving a review for our products</h3>
          <p>How would you describe your experience with our product?</p>
          <div className="d-flex justify-content-center align-content-center">
            <Rate
              value={value}
              onChange={(value) => setValue(value)}
              required
            />
          </div>
          <div className="form-group mb-2">
            <label>Review:</label>
            <Input.TextArea

              placeholder="write a review"
              value={formData.review}
              onChange={handleInputChange}
              style={{ backgroundColor: "#F6F6F6", resize: "none", height: "80px" }}
              name="review"
            />
          </div>
          <button
            key="submit"
            className="faq-get-in-touch-button"
            style={{ width: "100%" }}
            onClick={handleReview}
            type="primary"
          >
            Submit Review
          </button>
        </div>
      </Modal>
      <Modal
        visible={succesModalVisible}
        onCancel={() => setSuccesModalVisible(false)}
        footer={[]}
      >
        <div className="review-form">
          <div className="d-flex justify-content-center">
            <img src={star} alt="" />
          </div>
          <p> Thank You for submitting form</p>
          <div className="d-flex justify-content-center">
            <button className="faq-get-in-touch-button" onClick={redirectToShopPage}>
              Keep Browsing
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ProductReview;
